import React from 'react';
import { observer } from 'mobx-react';
import { Bengal } from './Bengal';

export const App = observer(() => {
    return <Bengal />;
});
